import { useState } from 'react';
import { Box } from '@chakra-ui/react';
import { FormikHelpers } from 'formik';
import { ISettingsValues } from 'types';
import { IRoleResource } from '../../../../../server/types';
import RoleForm, { RoleFormValues, RoleFormProps } from '../RoleForm/RoleForm';

type RoleProps = {
  data?: Partial<IRoleResource>;
  onSubmit: (values: RoleFormValues) => Promise<void>;
  settings: ISettingsValues | Record<string, never>;
} & Pick<RoleFormProps, 'pageOptions' | 'productOptions' | 'specificationOptions'>;

const Role = ({ data, onSubmit, settings, ...props }: RoleProps) => {
  const [error, setError] = useState<string | undefined>();
  const handleSubmit = async (values: RoleFormValues, { setSubmitting }: FormikHelpers<RoleFormValues>) => {
    setSubmitting(true);

    try {
      await onSubmit(values);
    } catch (err) {
      setError(err as string);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box>
      <RoleForm
        error={error}
        onSubmit={handleSubmit}
        buttonText={data ? 'UPDATE' : 'CREATE'}
        data={data}
        settings={settings}
        {...props}
      />
    </Box>
  );
};

export default Role;
